import { localStorageUserKey } from '../global'
import User from '../types/user'

const getUser = (): User | undefined => {
    const user = localStorage.getItem(localStorageUserKey)

    if (!user) {
        return undefined
    }

    try {
        return JSON.parse(user) as User
    } catch {
        return undefined
    }
}

const setUser = (data: User) => {
    localStorage.setItem(localStorageUserKey, JSON.stringify(data))
}

const removeUser = () => {
    localStorage.removeItem(localStorageUserKey)
}

const isAuthenticated = () => {
    const user = getUser()
    return Boolean(user?.uuid && user?.email)
}

export { getUser, setUser, removeUser, isAuthenticated }
